import { LwButton, Toolbox } from 'redesign';
import { useCompanyRelativePath } from 'ogp/hooks';
import { IconApproved, IconCancel } from 'assets/img';
import { routes } from 'ogp/Routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const SettingsEditToolbox = ({ handleSubmit }: { handleSubmit: () => void }) => {
  const generatePath = useCompanyRelativePath();
  const navigate = useNavigate();

  const { t } = useTranslation(['web-common']);

  const handleClose = () => {
    navigate(generatePath(routes.Settings));
  };

  return (
    <Toolbox underline>
      <LwButton onClick={handleSubmit} iconColorMode="stroke" startIcon={<IconApproved />}>
        {t('buttons.confirm', { ns: 'web-common' })}
      </LwButton>
      <LwButton
        onClick={handleClose}
        iconColorMode="fill"
        color="secondary"
        startIcon={<IconCancel />}
      >
        {t('buttons.cancel', { ns: 'web-common' })}
      </LwButton>
    </Toolbox>
  );
};
